import styled, {css} from 'styled-components';

const shawdowModifier = props => props.shadow && css`
  box-shadow: 1px 1px 0 0 rgba(0, 0, 0, 0.14);
`;

const borderRadiusModifier = props => !props.norounding && css`
  border-radius: 3px;
`;

const Card = styled.div`
    padding: 16px;
    background-color: #fff;
    margin-bottom: 16px;
    border: 1px solid rgba(187, 187, 187, .62);

    /* Modifiers */
    ${shawdowModifier}
    ${borderRadiusModifier}
`;

export default Card;

